/* JM added script to align the currency selector on the menu when on scroll.
   Vanilla since 2026-09-11 (HOMEPAGE_MOBILE_PERF_BATCH_PLAN.md B2): jQuery no longer loads on `index`. */
window.addEventListener('load', function () {
  var scrollPoint = 50;
  var targets = document.querySelectorAll('.baDropdownStyle');

  if (!targets.length) return;

  function handleScroll() {
    var scrolled = window.scrollY > scrollPoint;
    targets.forEach(function (el) {
      el.classList.toggle('scrolled', scrolled);
    });
  }

  // Check AFTER everything loads (fixes popup issue)
  handleScroll();

  // Check on scroll
  window.addEventListener('scroll', handleScroll, { passive: true });
});
